import React, { Fragment } from "react"
import PropTypes from "prop-types"
import Locations from "./locations"
import Map from "@geome/shell-locator-components/lib/components/map"
import { MAP_OPTIONS_DESKTOP, MAP_OPTIONS_MOBILE } from "./mapOptions"

class MapView extends React.Component {
  static propTypes = {
    locations: PropTypes.array,
    highlightedLocation: PropTypes.object,
    selectedLocation: PropTypes.object,
    directions: PropTypes.object,
    isShowingTraffic: PropTypes.bool,
    isMobile: PropTypes.bool,
    selectedPlace: PropTypes.object,
  }

  render() {
    const { isMobile, locations, highlightedLocation, selectedLocation, selectedPlace } = this.props

    return (
      <Map {...this.props} mapOptions={isMobile ? MAP_OPTIONS_MOBILE : MAP_OPTIONS_DESKTOP}>
        {({ handleOverlayRequest }) => (
          <Fragment>
            <Locations
              onOverlayRequest={handleOverlayRequest}
              locations={locations}
              highlighted={highlightedLocation}
              selected={selectedLocation}
              selectedPlace={selectedPlace}
            />
          </Fragment>
        )}
      </Map>
    )
  }
}

export default MapView
